function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// page dots
(function (window, factory) {
  // universal module definition
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('./core'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, utils) {
  // -------------------------- PageDots -------------------------- //
  function PageDots() {
    // create holder element
    this.holder = document.createElement('div');
    this.holder.className = 'flickity-page-dots'; // create dots, array of elements

    this.dots = [];
  }

  PageDots.prototype.setDots = function (slidesLength) {
    // get difference between number of slides and number of dots
    var delta = slidesLength - this.dots.length;

    if (delta > 0) {
      this.addDots(delta);
    } else if (delta < 0) {
      this.removeDots(-delta);
    }
  };

  PageDots.prototype.addDots = function (count) {
    var _this = this,
        _this$holder;

    var newDots = new Array(count).fill().map(function (item, i) {
      var dot = document.createElement('button');
      dot.setAttribute('type', 'button');
      var num = i + 1 + _this.dots.length;
      dot.className = 'flickity-page-dot';
      dot.textContent = "View slide ".concat(num);
      return dot;
    });

    (_this$holder = this.holder).append.apply(_this$holder, _toConsumableArray(newDots));

    this.dots = this.dots.concat(newDots);
  };

  PageDots.prototype.removeDots = function (count) {
    // remove from this.dots collection
    var removeDots = this.dots.splice(this.dots.length - count, count); // remove from DOM

    removeDots.forEach(function (dot) {
      return dot.remove();
    });
  };

  PageDots.prototype.updateSelected = function (index) {
    // remove selected class on previous
    if (this.selectedDot) {
      this.selectedDot.classList.remove('is-selected');
      this.selectedDot.removeAttribute('aria-current');
    } // don't proceed if no dots


    if (!this.dots.length) return;
    this.selectedDot = this.dots[index];
    this.selectedDot.classList.add('is-selected');
    this.selectedDot.setAttribute('aria-current', 'step');
  };

  Flickity.PageDots = PageDots; // -------------------------- Flickity -------------------------- //

  Object.assign(Flickity.defaults, {
    pageDots: true
  });

  Flickity.create.pageDots = function () {
    if (!this.options.pageDots) return;
    this.pageDots = new PageDots();
    this.handlePageDotsClick = this.onPageDotsClick.bind(this); // events

    this.on('activate', this.activatePageDots);
    this.on('select', this.updateSelectedPageDots);
    this.on('cellChange', this.updatePageDots);
    this.on('resize', this.updatePageDots);
    this.on('deactivate', this.deactivatePageDots);
  };

  var proto = Flickity.prototype;

  proto.activatePageDots = function () {
    var _this$focusableElems;

    this.pageDots.setDots(this.slides.length);

    (_this$focusableElems = this.focusableElems).push.apply(_this$focusableElems, _toConsumableArray(this.pageDots.dots));

    this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
    this.element.append(this.pageDots.holder);
  };

  proto.onPageDotsClick = function (event) {
    var index = this.pageDots.dots.indexOf(event.target);
    if (index === -1) return; // only dot clicks

    this.uiChange();
    this.select(index);
  };

  proto.updateSelectedPageDots = function () {
    this.pageDots.updateSelected(this.selectedIndex);
  };

  proto.updatePageDots = function () {
    var _this2 = this,
        _this$focusableElems2;

    this.pageDots.dots.forEach(function (dot) {
      utils.removeFrom(_this2.focusableElems, dot);
    });
    this.pageDots.setDots(this.slides.length);

    (_this$focusableElems2 = this.focusableElems).push.apply(_this$focusableElems2, _toConsumableArray(this.pageDots.dots));
  };

  proto.deactivatePageDots = function () {
    this.pageDots.holder.remove();
    this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
  }; // -----  ----- //


  Flickity.PageDots = PageDots;
  return Flickity;
});